interface RuntimeConfig {
  apiBaseUrl: string;
  wsUrl: string;
}

declare global {
  interface Window {
    __CONFIG__?: Partial<RuntimeConfig>;
  }
}

const runtime = window.__CONFIG__ ?? {};

export const config: RuntimeConfig = {
  // Precedence: runtime (window.__CONFIG__) > build-time (VITE_*) > dev fallback
  apiBaseUrl:
    runtime.apiBaseUrl ??
    import.meta.env.VITE_API_BASE_URL ??
    (import.meta.env.DEV ? '' : 'http://localhost:3000'),

  // Empty string → io() uses current window origin (nginx proxies /socket.io/)
  wsUrl:
    runtime.wsUrl ??
    import.meta.env.VITE_WS_URL ??
    (import.meta.env.DEV ? '' : 'http://localhost:3000'),
};
